'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');

var TabSelector = function (_React$Component) {
    _inherits(TabSelector, _React$Component);

    function TabSelector() {
        _classCallCheck(this, TabSelector);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    TabSelector.prototype.render = function render() {

        var tabClassNames = "tabRowContainer row ";
        if (this.props.extraTabRowClasses) tabClassNames += this.props.extraTabRowClasses;

        return React.createElement(
            'div',
            { className: tabClassNames, role: 'tablist' },
            React.createElement(
                'div',
                { className: 'btn-group btn-group-sm', role: 'group' },
                this.props.buttons.map(function (button, idx) {
                    return React.createElement(
                        'button',
                        {
                            key: 'tabSelector-' + idx,
                            type: 'button',
                            onClick: button.clickHandler,
                            className: 'btn ' + (button.isActive ? 'selected' : ''),
                            'aria-selected': button.isActive },
                        React.createElement('img', { src: button.image, alt: '', role: 'presentation' }),
                        React.createElement(
                            'span',
                            null,
                            button.text
                        )
                    );
                })
            )
        );
    };

    return TabSelector;
}(React.Component);

TabSelector.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape({
        clickHandler: PropTypes.func.isRequired,
        image: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired
    })),
    extraTabRowClasses: PropTypes.string
};


module.exports = TabSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/tabSelector.js
// module id = 733
// module chunks = 0